"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModuleResolutionsOutputDtoSchema = exports.getModuleResolutionsInputDtoSchema = exports.moduleResolutionFilterSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const hil_module_resolution_js_1 = require("../../types/hil-module-resolution.js");
function buildPackageStringWhere(column, operator, value) {
    const where = cadstrom_shared_1.QueryBuilder.buildStringOperatorClause(column, operator, value, { nonNullable: true });
    return where ? { package: { is: where } } : {};
}
function buildMetadataStringWhere(path, operator, value) {
    switch (operator) {
        case 'contains':
            return { metadata: { path, string_contains: value, mode: 'insensitive' } };
        case 'equals':
        case 'is':
            return { metadata: { path, equals: value } };
        case 'startsWith':
            return { metadata: { path, string_starts_with: value, mode: 'insensitive' } };
        case 'endsWith':
            return { metadata: { path, string_ends_with: value, mode: 'insensitive' } };
        case 'isAnyOf': {
            const values = cadstrom_shared_1.QueryBuilder.parseIsAnyOfValues(value);
            return { OR: values.map((v) => ({ metadata: { path, equals: v } })) };
        }
        default:
            return {};
    }
}
exports.moduleResolutionFilterSchema = cadstrom_shared_1.QueryBuilder.createFilterSchema({
    fields: {
        id: {
            description: 'BOM item id for the module resolution.',
            options: { type: cadstrom_shared_1.QueryBuilder.FieldType.String },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual'],
        },
        moduleRef: {
            description: 'Reference designator for the module, e.g. U1 or R3.',
            options: { type: cadstrom_shared_1.QueryBuilder.FieldType.String, column: 'referenceDesignator', nonNullable: true },
        },
        isReviewed: {
            description: 'True if the module resolution has been reviewed.',
            options: { type: cadstrom_shared_1.QueryBuilder.FieldType.Boolean },
        },
        packageId: {
            description: 'Package-store package id selected for package-store resolutions.',
            options: { type: cadstrom_shared_1.QueryBuilder.FieldType.String, nonNullable: false },
            allowedOperators: ['equals', 'is', 'isAnyOf', 'not', 'doesNotEqual', 'isEmpty', 'isNotEmpty'],
        },
        manufacturerPartNumber: {
            description: 'Manufacturer part number of the selected package-store package.',
            options: {
                type: cadstrom_shared_1.QueryBuilder.FieldType.Custom,
                buildWhere: (operator, value) => buildPackageStringWhere('manufacturerPartNumber', operator, value),
                buildOrderBy: (direction) => [{ package: { manufacturerPartNumber: direction } }],
            },
            allowedOperators: ['contains', 'equals', 'is', 'startsWith', 'endsWith', 'isAnyOf'],
        },
        packageStatus: {
            description: 'Publication status of the selected package-store package.',
            options: {
                type: cadstrom_shared_1.QueryBuilder.FieldType.Custom,
                buildWhere: (operator, value) => buildPackageStringWhere('status', operator, value),
                buildOrderBy: (direction) => [{ package: { status: direction } }],
            },
            allowedOperators: ['equals', 'is', 'isAnyOf'],
        },
        moduleDatasheetUrl: {
            description: 'Datasheet URL attached to the project module.',
            options: {
                type: cadstrom_shared_1.QueryBuilder.FieldType.Custom,
                buildWhere: (operator, value) => buildMetadataStringWhere(['moduleDatasheetUrl'], operator, value),
            },
            allowedOperators: ['contains', 'equals', 'is', 'startsWith', 'endsWith', 'isAnyOf'],
        },
        moduleDatasheetFileId: {
            description: 'Datasheet file id attached to the project module.',
            options: {
                type: cadstrom_shared_1.QueryBuilder.FieldType.Custom,
                buildWhere: (operator, value) => buildMetadataStringWhere(['moduleDatasheetFileId'], operator, value),
            },
            allowedOperators: ['equals', 'is', 'isAnyOf'],
        },
    },
});
exports.getModuleResolutionsInputDtoSchema = z.object({
    projectId: z.string(),
    buildId: z.string(),
    filters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(exports.moduleResolutionFilterSchema).optional(),
    filterLogicOperator: cadstrom_shared_1.QueryBuilder.logicOperatorSchema
        .optional()
        .describe('How to combine filters. Defaults to "and".'),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(exports.moduleResolutionFilterSchema).optional(),
});
exports.getModuleResolutionsOutputDtoSchema = z.object({
    moduleResolutions: hil_module_resolution_js_1.HilModuleResolution.schema.array(),
});
//# sourceMappingURL=get-module-resolutions.js.map